module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starFilled@3x-89dcff54adfca7dc361463fd8762aa4c.png";